export default __webpack_public_path__ + "static/media/triangle.1d6dcfd3.svg";